import RepeatReferralFormContainer from './repeat-referral-form-container';

export default RepeatReferralFormContainer;
